import {Component, Inject, OnDestroy, OnInit} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ToastrService } from "ngx-toastr";
import { SessionService } from "src/app/features/shared/services/Session.service";
import { LocalStorageService } from "src/app/features/shared/services/LocalStorage.service";

import { environment } from "src/environments/environment";
import { EstatusJSON } from "src/app/features/shared/models/EstatusJSON";
import { forkJoin, of, Subscription } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { FilterDefinition, FilterDialogData, SelectedFilter } from "../../../../../models/Filters";
import { FilterMapService } from "../../../../../services/Filter-Map.service";

@Component({
  selector: "filter-categories",
  templateUrl: "./filter-categories.component.html",
  styleUrls: ["./filter-categories.component.css"],
})
export class FilterCategoriesComponent implements OnInit, OnDestroy {
  isLoading: boolean = true;
  form: FormGroup;
  filters: FilterDefinition[] = [];
  valuesFiltered: SelectedFilter[] = [];

  moduleSearch: string = "filters_LocationCategory";

  idLocationCategory: number = null;

  subscription_GetFilters: Subscription;
  subscription_GetValuesFilters: Subscription;

  constructor(
    public dialogRef: MatDialogRef<FilterCategoriesComponent>,
    private sessionService: SessionService,
    private toastService: ToastrService,
    private localStorageService: LocalStorageService,
    private filterMapService: FilterMapService,
    @Inject(MAT_DIALOG_DATA) private data: FilterDialogData
  ) {
    if (!environment.production) console.log("ava data", data);

    this.form = new FormGroup({});

    this.valuesFiltered = data.selected ? data.selected.map(s => ({ ...s })) : [];
    this.idLocationCategory = data.idLocationCategory;
    this.moduleSearch = data.moduleName ? data.moduleName : "filters_LocationCategory";

    if (data.filters != null && data.filters.length > 0) {
      var inputFilters = data.filters.map( filter => ({ ...filter, display: filter.display ? filter.display : filter.key, module: filter.module || data.moduleName || '' }) );
      if (data.idLocationCategory != null) {
        inputFilters = data.filters.filter( (f) => f.idLocationCategory == data.idLocationCategory );
      }
      this.filters = inputFilters.sort((a, b) => (a.key < b.key ? -1 : 1));

      const group: any = {};
      this.filters.forEach((element) => {
        if (this.valuesFiltered.some((x) => x.key == element.key)) {
          element.selected = this.valuesFiltered[ this.valuesFiltered.findIndex((x) => x.key == element.key) ].value;
        } else {
          element.selected = "";
        }
        group[element.key] = new FormControl(element.selected);
      });

      this.form = new FormGroup(group);
      this.isLoading = false;
    } else {
      this.getFilters();
    }
  }

  ngOnInit(): void {
    this.checkingURL();
  }

  ngOnDestroy(): void {
    if (this.subscription_GetFilters) this.subscription_GetFilters.unsubscribe();
    if (this.subscription_GetValuesFilters) this.subscription_GetValuesFilters.unsubscribe();
  }

  checkingURL() {
    this.sessionService.CheckURLSource();
  }

  addFilter($filter: SelectedFilter) {
    if (this.filters.some((x) => x.key == $filter.key)) {
      const valueIndex = this.valuesFiltered.findIndex( (x) => x.key == $filter.key );
      if (valueIndex == -1) {
        this.valuesFiltered.push({ key: $filter.key, value: $filter.value, module: $filter.module || '' });
      } else {
        this.valuesFiltered[valueIndex].value = $filter.value;
        this.valuesFiltered[valueIndex].module = $filter.module || '';
      }
    }
  }

  dropFilter($filter: SelectedFilter) {
    const valueIndex = this.valuesFiltered.findIndex( (x) => x.key == $filter.key );

    if (valueIndex >= 0) {
      this.valuesFiltered.splice(valueIndex, 1);
    }
  }

  clear() {
    this.form.reset();
    this.filters.forEach((element) => {
      element.selected = "";
    });
    this.valuesFiltered = [];
    this.dialogRef.close({
      search: true,
      filtersSelected: this.valuesFiltered,
      idLocationCategory: this.idLocationCategory,
    });
  }

  cancel() {
    this.dialogRef.close({ search: false });
  }

  accept() {
    this.dialogRef.close({
      search: true,
      filtersSelected: this.valuesFiltered,
      idLocationCategory: this.idLocationCategory,
    });
  }

  getFilters() {
    this.subscription_GetFilters = this.filterMapService.getFiltersByModule(this.moduleSearch)
      .subscribe({
        next: (data: EstatusJSON) => {
          const filters = data.result;
          if (filters == null || filters.length == 0) {
            this.isLoading = false;
            return;
          }

          filters.forEach((element) => element.module = this.moduleSearch);

          const valueRequests = filters.map((element) =>
            this.filterMapService.getValuesByFilterModule(element.key, this.moduleSearch).pipe(
              map((res) => ({ element, filterValues: res.result })),
              catchError((error) => {
                console.error("Error al obtener valores de filtros", error);
                return of({ element, filterValues: [] });
              })
            )
          );

          this.subscription_GetValuesFilters = forkJoin(valueRequests).subscribe((results: { element: any, filterValues: any[] }[]) => {
            results.forEach(({ element, filterValues }) => {
              this.filters.push({
                key: element.key,
                display: element.value ? element.value : element.key,
                values: filterValues,
                idLocationCategory: element.idLocationCategory ? element.idLocationCategory : null,
                module: element.module ? element.module : this.moduleSearch
              });
            });

            const group: any = {};
            this.filters.forEach((element) => {
              if (this.valuesFiltered.some((x) => x.key == element.key)) {
                element.selected = this.valuesFiltered[  this.valuesFiltered.findIndex((x) => x.key == element.key) ].value;
              } else {
                element.selected = "";
              }
              group[element.key] = new FormControl(element.selected);
            });

            this.form = new FormGroup(group);
            this.isLoading = false;
            if (!environment.production) console.log("Filters", this.filters);
          });
        },
        error: (error) => {
          console.error("Error al obtener filtros por módulo", error);
          this.isLoading = false;
        },
      });
  }
}
